import { getCSSFileName, getMasterData, getThemeByOrganisationId } from '../api/bootstrap';
import { updateFinancingCtaStatus } from '../api/users';
import { HARDCODED_MASTER_DATA, SIDEMENU_CONFIG, USE_HARDCODED_MASTER_DATA } from '../globals';
import { getAuthorizationConfig, getSectionsToShow } from '../utils/partsToShow/helper';
import {
  INITIALIZE_COMPLETE,
  MASTER_DATA_FETCH_ERROR,
  SET_AUTHORIZATION_CONFIG,
  SET_MASTER_DATA,
  SET_SECTIONS_TO_SHOW,
  SET_UI_THEME,
  SET_USER_AGREEMENT,
  UPDATE_FINANCING_CTA_VISIBILITY_STATUS,
} from './constants';
import { fetchUsers } from './userManagementActions';

export const loadInitialData = (params: any) => async (dispatch) => {
  if (USE_HARDCODED_MASTER_DATA) {
    dispatch({
      type: SET_MASTER_DATA,
      data: HARDCODED_MASTER_DATA,
    });
  } else {
    // rest api call
    fetchUsers()(dispatch);
    const masterDataResponse: any = await getMasterData(params);
    if (masterDataResponse.isSuccess) {
      const {
        userData,
        show_task_workflow,
        organisationModesOfService,
        permissions,
      } = masterDataResponse.masterData;
      window.localStorage.setItem('isTestOrg', masterDataResponse.masterData.isTestOrg);
      const modules = Object.assign({}, SIDEMENU_CONFIG, masterDataResponse.masterData.modules);

      // Filter show_master_categories based on permission flags
      if (
        modules.show_master_categories &&
        Array.isArray(modules.show_master_categories) &&
        permissions
      ) {
        modules.show_master_categories = modules.show_master_categories.filter(
          (category: string) => {
            if (category === 'DSR_TEMPLATE') {
              return true;
            }
            // Map FF to VENDOR for permission check
            const permissionCategory = category === 'FF' ? 'VENDOR' : category;
            const permissionKey = `MASTERS_${permissionCategory}_VIEW`;
            return permissions[permissionKey] === true;
          }
        );
      }

      const partsToShow = getAuthorizationConfig(
        modules,
        userData,
        show_task_workflow,
        permissions
      );

      // Update masterData with filtered modules
      const masterDataWithFilteredModules = {
        ...masterDataResponse.masterData,
        modules,
      };

      dispatch({
        type: SET_MASTER_DATA,
        data: masterDataWithFilteredModules,
      });
      dispatch({
        type: SET_AUTHORIZATION_CONFIG,
        data: partsToShow,
      });
      dispatch({
        type: SET_SECTIONS_TO_SHOW,
        data: getSectionsToShow(partsToShow),
      });
      dispatch({
        type: INITIALIZE_COMPLETE,
      });
      return;
    }
    dispatch({
      type: INITIALIZE_COMPLETE,
    });
    dispatch({
      type: MASTER_DATA_FETCH_ERROR,
      errorMessage: masterDataResponse.errorMessage,
    });
  }
};

export const setPrivacyAgreement = () => (dispatch) => {
  dispatch({
    type: SET_USER_AGREEMENT,
  });
};

export const getFileName = () => async (dispatch) => {
  const fileNameStatus = await getCSSFileName();
  return fileNameStatus;
};

export const getTheme = () => async (dispatch) => {
  const themeResponse = await getThemeByOrganisationId();
  if (themeResponse.isSuccess) {
    dispatch({
      type: SET_UI_THEME,
      data: themeResponse.data,
    });
  }
};

export const updateFinancingCtaVisibilityStatus = () => async (dispatch) => {
  const response = await updateFinancingCtaStatus({ status: false });
  dispatch({
    type: UPDATE_FINANCING_CTA_VISIBILITY_STATUS,
  });
};
